import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { getHistory } from './app/router/history/history';

if (environment.production) {
  enableProdMode();
}

// URLs used to be hashbang based (/ui/#!/workflow/1), old bookmarks and mails still use them.
// The fragment never reaches the server, so rewrite it to the path (/ui/workflow/1) before the router starts.
if (window.location.hash.startsWith('#!')) {
  const url = new URL(window.location.hash.slice(2).replace(/^\//, ''), document.baseURI);
  window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
}

getHistory();

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], });
